import type { Recipe } from "@/pages/sy/models/Recipe";

export const VIEW_MODE = {
  READ: "read",
  EDIT: "edit",
} as const;

export type ViewMode = (typeof VIEW_MODE)[keyof typeof VIEW_MODE];

export const MODAL_STATE = {
  NEW: "new",
  EDIT: "edit",
  DELETE: "delete",
  CLOSED: "",
} as const;

export type ModalState = (typeof MODAL_STATE)[keyof typeof MODAL_STATE];

export interface ModalData {
  open: boolean;
  recipe: Recipe | null;
}

export interface ModalHideParams {
  shouldUpdate: boolean;
  close: boolean;
  entityId?: number;
  keepEditMode?: boolean;
}
